import React, { useEffect, useState, useRef } from "react";
import "./MessageA3ud.css"; // Import the CSS file
import PackDescriptionComponent from "../../CommonUtils/SelectChannelsAndPacks/PackDesription/PackDescriptionComponent";

const MessageA3ud = ({ data, showMaximumChat }) => {
  let data1 = JSON.parse(data)

  const { channels, packs, ott, freePacks } = data1;
  const [enableDescriptionComponent, setEnableDescriptionComponent] = useState({
    toggle: false,
    data: null,
  });

  const formatDate = (inputDate) => {

    const formatted = new Date(inputDate).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
    return formatted
  }


  const enableDescription = (e, data) => {
    e?.stopPropagation?.();

    if (data) {
      localStorage.setItem("packDescription", JSON.stringify(data));
      setEnableDescriptionComponent({
        toggle: true,
        data,
      });
    }
  };
  const selectDescription = (data) => {
    // onPackClickHandler(enableDescriptionComponent.data);
    setEnableDescriptionComponent({
      toggle: false,
      data: null,
    });
  };

  return (
    <>
      {enableDescriptionComponent.toggle && (
        <PackDescriptionComponent
          data={enableDescriptionComponent.data}
          closeDescriptionComponent={() => setEnableDescriptionComponent(false)}
          selectDesctipon={() => selectDescription()}
          showMaximumChat={showMaximumChat}
          showGetPack={true}
        />
      )}

      <div className="subscription-container">
        {/* Channels */}
        {channels?.length > 0 && (
          <div>
            <h2 className="section-title">Channels :</h2>
            <p className="section-subtitle">Purchased Over and Above Packs</p>
            <div className="card-group">
              {channels.flat().map((ch, index) => (
                <div key={index} style={{ width: showMaximumChat ? '94%' : '90%' }} className="channel-card">
                  <div style={{ display: "flex", flexDirection: 'column' }}>
                    <span className="channel-name">{ch.channel_name}</span>
                    <span className="channel-info">Ch. {ch.epg_number}</span>
                  </div>
                  <p className="price">₹{ch.pack_mrp.toFixed(2)}/month</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Packs */}
        {packs?.packList?.length > 0 && (
          <div>
            <h2 className="section-title">Packs :</h2>
            <p className="section-subtitle">Group of channels with savings</p>
            <div className="card-group">
              {packs?.packList?.flat().map((pack, idx) => (
                <div key={idx} style={{ width: showMaximumChat ? '94%' : '90%' }} className="channel-card">
                  <div class="pack-name-col">
                    <span className="channel-name">{pack?.name}</span>
                    <button onClick={(e) => enableDescription(e, pack)} className="channel-link">View Channel List</button>
                  </div>
                  <div className="price-col">
                    {pack?.description && <span style={{ fontWeight: '600', fontSize: '12px' }} className={`${pack?.status === "Active" ? "active" : "on-hold"}`} >
                      ₹{pack?.description}
                    </span>}
                    {pack?.status && <span style={{ fontWeight: '600', marginTop: '6px' }} className={`${pack?.status === "Active" ? "active" : "on-hold"}`}>
                      {pack?.status}
                    </span>}
                  </div>
                </div>
              ))}
            </div>
          </div>)}

        {/* OTT Apps */}
        {ott?.packList?.length > 0 && (
          <div>
            <h2 className="section-title">OTT Apps:</h2>
            <div className="card-group">
              {ott?.packList?.flat().map((pack, idx) => (
                <div key={idx} style={{ width: showMaximumChat ? '94%' : '90%' }} className="channel-card">
                  <div class="pack-name-col">
                    <span className="channel-name">{pack?.name}</span>
                    <button onClick={(e) => enableDescription(e, pack)} className="channel-link">View Channel List</button>
                  </div>
                  <div className="price-col">
                    {pack?.description && <span style={{ fontWeight: '600', fontSize: '12px' }} className={`${pack?.status === "Active" ? "active" : "on-hold"}`}>
                      ₹{pack?.description}
                    </span>}
                    {pack?.status && <span style={{ fontWeight: '600', marginTop: '6px' }} className={` ${pack?.status === "Active" ? "active" : "on-hold"}`}>
                      {pack?.status}
                    </span>}
                    {pack?.vaild && <span style={{ fontWeight: '600', marginTop: '6px' }} className={` ${pack?.status === "Active" ? "active" : "on-hold"}`}>
                      Vaild till {`${formatDate(pack?.vaild)}`}
                    </span>}
                  </div>
                </div>
              ))}

            </div>
          </div>
        )}

        {/* Free & Complimentary */}
        {freePacks?.packList?.length > 0 && (
          <div>
            <h2 className="section-title">Free & Complimentary :</h2>
            {freePacks?.packList?.flat().map((pack, idx) => (
              <div key={idx} style={{ width: showMaximumChat ? '94%' : '90%' }} className="channel-card">
                <div class="pack-name-col">
                  <span className="channel-name">{pack?.name}</span>
                  <button onClick={(e) => enableDescription(e, pack)} className="channel-link">View Channel List</button>
                </div>
                <p className="free price-col">FREE</p>
              </div>
            ))}
          </div>)}
      </div>
    </>
  );
};

export default MessageA3ud;
